import { React, useState } from 'react';

import '../style/header.scss';

import close from "../images/svg/close.svg";

const Login = ({closePopUp}) => {
	
	
	return (
		
			<div className="popup-flex">
				<div className="rules-box popup-box">
					<img src={close} onClick={() => closePopUp()} className="rules-close-button popup-close-button" alt="icon" />
					<h3 className="rules-title align-center">Hey, we have new points system!</h3>
					<p>We’ve introduced a new “Points” system to make your game lively! Let’s see how this works.</p>
					<ul>
						<li className="rules-li">Points are now timed. The more time you take, the less points you get.</li>
						<li className="rules-li">Every wrong puzzle would result in deduction of certain points. But these are deducted only once.</li>
						<li className="rules-li">You can try mulitple attempts to clear a puzzle after a wrong move without worrying about the points.</li>
						<li className="rules-li">
							"Unrated" means the puzzle doesn’t carry points and it could come in multiple scenarios:
							<ul>
								<li className="rules-li">After one wrong move</li>
								<li className="rules-li">After you use a hint</li>	
							</ul>
						</li>
					</ul>
					<div className="rules-click-box wdh display-flex justify-center">
						<span className="rules-click button-click" onClick={() => closePopUp()}>Got it! Let’s play</span>
					</div>
				</div>
			</div>

	);

  
}

export default Login;